import { ExternalLink, Gift, Sparkles, Crown } from 'lucide-react';

const Offers = () => {
  const offers = [
    {
      id: 1,
      name: '888 Casino',
      url: 'https://www.888casino.com/',
      bonus: '200% up to £200 Bonus',
      icon: <Crown className="text-toxic-orange" size={32} />,
      description: 'Double your first deposit instantly with this powerhouse welcome package. Start with more, win bigger.',
      bgGradient: 'from-purple-900/20 to-dark-black',
      borderColor: 'border-purple-500/30'
    },
    {
      id: 2,
      name: 'Kwiff',
      url: 'https://www.kwiff.com',
      bonus: '£20 on slots + 40 Free Spins',
      icon: <Sparkles className="text-toxic-orange" size={32} />,
      description: 'Instant cashback plus free spins on your favorite slots. No wagering requirements on the bonus cash.',
      bgGradient: 'from-blue-900/20 to-dark-black',
      borderColor: 'border-blue-500/30'
    },
    {
      id: 3,
      name: 'Plaza Royal',
      url: 'https://www.plazaroyal.com',
      bonus: '100% up to £50 + 20 Spins',
      icon: <Gift className="text-toxic-orange" size={32} />,
      description: 'Match your deposit pound for pound and unlock 20 free spins on premium slot titles.',
      bgGradient: 'from-green-900/20 to-dark-black',
      borderColor: 'border-green-500/30'
    }
  ];

  return (
    <section id="offers" className="py-20 bg-dark-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Exclusive Casino Offers
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Handpicked bonuses from trusted UK operators. Each offer has been verified for fairness and value.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {offers.map((offer, index) => (
            <div
              key={offer.id}
              itemScope
              itemType="https://schema.org/Offer"
              className={`relative bg-gradient-to-br ${offer.bgGradient} border-2 ${offer.borderColor} rounded-xl p-8 hover:border-toxic-orange transition-all duration-300 transform hover:-translate-y-2`}
            >
              <div className="flex items-start justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="relative w-16 h-16 bg-gray-800 rounded-lg flex items-center justify-center border border-gray-700 overflow-hidden">
                    <img 
                      src={`/images/${index === 0 ? 'kenny-eliason-VOHZuZ8U4Lg-unsplash.webp' : index === 1 ? 'james-nilsson-Ih32pz1tMis-unsplash.webp' : 'jaroslaw-kwoczala-nlor0fa24xI-unsplash.webp'}`} 
                      alt={`${offer.name}`} 
                      className="w-full h-full object-cover opacity-30"
                      itemProp="image"
                    />
                    <div className="absolute inset-0 flex items-center justify-center">
                      {offer.icon}
                    </div>
                  </div>
                </div>
                <span className="text-xs text-gray-500 bg-gray-800 px-3 py-1 rounded-full">
                  #{index + 1} Top Pick
                </span>
              </div>

              <h3 className="text-2xl font-bold text-white mb-3" itemProp="name">{offer.name}</h3>
              
              <div className="mb-4">
                <span className="text-toxic-orange font-semibold text-lg block mb-2" itemProp="description">
                  {offer.bonus}
                </span>
                <p className="text-gray-300 text-sm leading-relaxed" itemProp="description">
                  {offer.description}
                </p>
              </div>

              <a
                href={offer.url}
                target="_blank"
                rel="noopener noreferrer nofollow sponsored"
                className="block w-full bg-toxic-orange text-dark-black text-center py-3 rounded-lg font-semibold hover:bg-orange-500 transition-colors flex items-center justify-center group"
              >
                Play at {offer.name}
                <ExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
              </a>

              <div className="mt-4 text-xs text-gray-500 text-center">
                T&Cs apply. 18+ only. BeGambleAware.org
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offers;

